import React from 'react';
import Modal, { ModalHeader, ModalBody } from '../Modal';
import localize from '../localize';
import './Search.css';
import { openSearch, closeSearch, setSearchStep } from '../../actions/search';
import FindLocation from '../FindLocation';
import Location from '../Location';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import statsTracker from '../../utils/stats_tracker';

const SearchHeader = localize('search.modal.step_search')(({ i18n }) => {
  return (
    <header className="text-center">
      <h1>{i18n.t('header')}</h1>
      <h2>{i18n.t('subheader')}</h2>
    </header>);
});

const LocationSelectHeader = localize('search.modal.step_location')(({ i18n }) => {
  return (
    <header className="text-center">
      <h1>{i18n.t('header')}</h1>
      <h2>{i18n.t('subheader')}</h2>
    </header>
  );
});

const LocationNotFound = localize('search.modal.not_found')(({ i18n, onClose }) => {
  return (
      <div>
        <ModalHeader>
          <header className="text-center">
            <h1>{ i18n.t('header') }</h1>
          </header>
        </ModalHeader>
        <ModalBody>
          <div className="content">
            { i18n.t('content') }

            <div className="form-actions"><q-button onClick={onClose}>{ i18n.t('close') }</q-button></div>
          </div>
        </ModalBody>
      </div>
    );
});

class LocationSearchBare extends React.Component {
  onLocationSelected({ shard, location_id }) {
    this.props.closeSearch();
    this.props.history.push(`/results/${shard}/${location_id}`);
  }

  onLocationNotFound() {
    this.props.setSearchStep('notfound');
  }

  render() {
    const { i18n, shard, currentLocation, step, searchOpen, openSearch, closeSearch, children } = this.props;

    return (<div className="locationSearch">
              <div className="centered-content">
                <div onClick={() => {
                  statsTracker.trackEvent('click', 'search');
                  openSearch();
                }}>
                  { children }
                </div>
              </div>
              <Modal handleModalClose={() => closeSearch()} isOpen={searchOpen} contentLabel={i18n.t('modal.header')}>
                {step === 'search' &&
                  <FindLocation
                    onLocationSelected={(values, dispatch) => this.onLocationSelected(values, dispatch)}
                    onLocationNotFound={() => this.onLocationNotFound()}
                    shard={shard}
                    country={currentLocation && currentLocation.country_code}
                    searchHeader={<SearchHeader />}
                    locationHeader={<LocationSelectHeader />} /> }
                {step === 'notfound' &&
                  <LocationNotFound onClose={() => closeSearch()} />
                }
              </Modal>
            </div>);
  }
}

export const LocationSearchEmpty = compose(withRouter, connect(state => ({
    searchOpen: state.search.isOpen,
    step: state.search.step
  }),
  dispatch => ({
    openSearch: () => dispatch(openSearch()),
    closeSearch: () => dispatch(closeSearch()),
    setSearchStep: (step) => dispatch(setSearchStep(step))
  })
), localize('search'))(LocationSearchBare);

export default compose(withRouter, connect(state => ({
    searchOpen: state.search.isOpen,
    step: state.search.step
  }),
  dispatch => ({
    openSearch: () => dispatch(openSearch()),
    closeSearch: () => dispatch(closeSearch()),
    setSearchStep: (step) => dispatch(setSearchStep(step))
  })
), localize('search'))((props) => (
  <LocationSearchBare {...props}>
    <div className="currentLocation">
      <q-icon name="search" size="md" />
      {props.showLocation && props.currentLocation? <Location location={props.currentLocation} /> : props.i18n.t('header')}
      <div className="location-label">
        <span>{props.i18n.country((props.currentLocation || {}).country_code)}</span>
        <span>{props.i18n.t(`shards.${props.shard}`, false)}</span>
      </div>
    </div>
  </LocationSearchBare>
))



// WEBPACK FOOTER //
// ./src/components/Search/index.js